import React from "react";
import { IonIcon, IonText } from "@ionic/react";
import { toast, ToastOptions } from "react-toastify";
import { checkmarkCircleOutline, closeCircleOutline } from "ionicons/icons";

const ToastSuccessMessage = (message: string) => {
  return (
    <div className="toast-content-container">
      <IonIcon icon={checkmarkCircleOutline} />
      <IonText>{message}</IonText>
    </div>
  );
};

export const ShowToastSuccessMessage = (
  message: string,
  options?: ToastOptions
) => {
  const toastOptions = options ? options : {};

  toast.success(ToastSuccessMessage(message), {
    position: "bottom-center",
    autoClose: 4000,
    className: "toast-msg-success",
    hideProgressBar: true,
    closeButton: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    ...toastOptions,
  });
};

const ToastErrorMessage = (message: string) => {
  return (
    <div className="toast-content-container">
      <IonIcon icon={closeCircleOutline} />
      <IonText>{message}</IonText>
    </div>
  );
};

export const ShowToastErrorMessage = (
  message: string,
  options?: ToastOptions
) => {
  const toastOptions = options ? options : {};

  toast.error(ToastErrorMessage(message), {
    position: "bottom-center",
    autoClose: 4000,
    className: "toast-msg-error",
    hideProgressBar: true,
    closeButton: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    ...toastOptions,
  });
};
